import {createAction, props} from '@ngrx/store';
import {IAuthenticatorSetupVerifyResponse} from '../models/authenticator-setup-verify.response.model';
import {IAuthenticatorSetupResponse} from '../models/authenticator-setup.response.model';

export enum AuthenticatorSetupActions {
  LoadAuthenticatorSetup = '[MfaOptionsComponent] Load Authenticator Setup',
  LoadAuthenticatorSetupSuccess = '[MfaSetupEffects] Load Authenticator Setup Success',
  LoadAuthenticatorSetupFailure = '[MfaSetupEffects] Load Authenticator Setup Failure',
  LoadAuthenticatorSetupError = '[MfaSetupEffects] Load Authenticator Setup Error',
  CancelAuthenticatorSetup = '[AuthenticatorAppConfigComponent] Cancel Authenticator Setup',
  CancelAuthenticatorSetupSuccess = '[MfaSetupEffects] Cancel Authenticator Setup Success',
  CancelAuthenticatorSetupError = '[MfaSetupEffects] Cancel Authenticator Setup Error',
  VerifyAuthenticatorSetup = '[AuthenticatorAppOtpSetupComponent] Verify Authenticator Setup',
  VerifyAuthenticatorSetupSuccess = '[MfaSetupEffects] Verify Authenticator Setup Success',
  VerifyAuthenticatorSetupError = '[MfaSetupEffects] Verify Authenticator Setup Error',
  ResetAuthenticatorSetupState = '[RecoverycodesListComponent / MfaSetupEffects / requireAuthenticatorSetup] Reset Authenticator Setup State',
}

export const loadAuthenticatorSetup = createAction(AuthenticatorSetupActions.LoadAuthenticatorSetup);

export const loadAuthenticatorSetupSuccess = createAction(
  AuthenticatorSetupActions.LoadAuthenticatorSetupSuccess,
  props<{response: IAuthenticatorSetupResponse}>()
);

export const loadAuthenticatorSetupFailure = createAction(
  AuthenticatorSetupActions.LoadAuthenticatorSetupFailure,
  props<{reason: string}>()
);

export const loadAuthenticatorSetupError = createAction(
  AuthenticatorSetupActions.LoadAuthenticatorSetupError,
  props<{error: string}>()
);

export const cancelAuthenticatorSetup = createAction(AuthenticatorSetupActions.CancelAuthenticatorSetup);

export const cancelAuthenticatorSetupSuccess = createAction(AuthenticatorSetupActions.CancelAuthenticatorSetupSuccess);

export const cancelAuthenticatorSetupError = createAction(
  AuthenticatorSetupActions.CancelAuthenticatorSetupError,
  props<{error: string}>()
);

export const verifyAuthenticatorSetup = createAction(
  AuthenticatorSetupActions.VerifyAuthenticatorSetup,
  props<{code: string}>()
);

export const verifyAuthenticatorSetupSuccess = createAction(
  AuthenticatorSetupActions.VerifyAuthenticatorSetupSuccess,
  props<{response: IAuthenticatorSetupVerifyResponse}>()
);

export const verifyAuthenticatorSetupError = createAction(
  AuthenticatorSetupActions.VerifyAuthenticatorSetupError,
  props<{error: string}>()
);

export const resetAuthenticatorSetupState = createAction(AuthenticatorSetupActions.ResetAuthenticatorSetupState);
